import * as React from 'react';
import { connect } from 'react-redux';

import { Banner, IBannerProps } from '@abb/common-ux';
import { IConnectedComponent } from '../../../../reducers';

class BannerContainer extends React.Component<IBannerContainerProps & IConnectedComponent, any> {
  constructor(props: any) {
    super(props);    
  }

  removeBanner = (banner: IBannerProps) => {
    const dispatch = this.props.dispatch;
    dispatch({ type: 'REMOVE_BANNER', banners: [banner] });
  }
  
  render() {
    const banners = [];    
    if (this.props.banners) {
      for (let i = 0; i < this.props.banners.length; i++) {
        banners[i] = <Banner key={i} {...this.props.banners[i]} onRemove={this.removeBanner}>{this.props.banners[i].children}</Banner>;
      }
    }

    return (
      <div className='bannerContainer'>
        {banners}
      </div>
    );
  }
}

export default connect((store: any) => ({
  banners: store.bannerState.banners 
}))(BannerContainer as any);

export interface IBannerContainerProps {
  readonly banners: IBannerProps[];
}
